import {
  Accessibility,
  Armchair,
  ArrowLeftRight,
  Award,
  BarChart3,
  BookMarked,
  BookOpen,
  Boxes,
  Briefcase,
  Building2,
  Bus,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  Car,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Coins,
  Construction,
  Contact,
  DoorOpen,
  Dumbbell,
  FileBarChart,
  FileCheck,
  FileDown,
  FileQuestion,
  FileSignature,
  FileSpreadsheet,
  FileText,
  Flag,
  Fuel,
  Globe,
  GraduationCap,
  Banknote,
  History,
  Home,
  Info,
  Landmark,
  LayoutDashboard,
  LayoutGrid,
  Layers,
  ListChecks,
  ListOrdered,
  MapPin,
  Megaphone,
  Network,
  BookOpenText,
  Package,
  PartyPopper,
  PieChart,
  PiggyBank,
  Pill,
  Plane,
  Receipt,
  Repeat,
  Route,
  Scale,
  School,
  Send,
  Settings,
  Shield,
  ShoppingCart,
  SlidersHorizontal,
  Sparkles,
  Stethoscope,
  Sticker,
  Tags,
  Trash2,
  Trophy,
  UserCheck,
  UserCog,
  UserPlus,
  UserRound,
  Users,
  Wallet,
  Warehouse,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react'

/** Lucide glyph for each sidebar destination, by route. */
const BY_HREF: Record<string, LucideIcon> = {
  '/home': LayoutDashboard,
  '/calendar': CalendarDays,
  '/calendar/events': CalendarDays,
  '/settings/school-days': CalendarDays,
  '/school-hub': School,
  '/time-table/teachers': UserRound,
  '/time-table/classes': LayoutGrid,
  '/time-table/subjects': BookOpen,
  '/time-table/period-distribution': PieChart,
  '/time-table/departments': Building2,
  '/time-table/bell-timings': Clock,
  '/time-table/generate': Sparkles,
  '/time-table/class-wise': CalendarDays,
  '/time-table/teacher-wise': CalendarClock,
  '/time-table/substitution': Repeat,
  '/time-table/versions': History,
  '/time-table/formats': FileDown,

  '/stdnt/stdntboard': Home,
  '/stdnt/students': Users,
  '/stdnt/classes': LayoutGrid,
  '/stdnt/subjects': BookOpen,
  '/stdnt/alumni': GraduationCap,

  '/staaf/overview': Home,
  '/staaf/organisation-structure': Network,
  '/staaf/teaching-staff': Briefcase,
  '/staaf/sports-coach': Dumbbell,
  '/staaf/admin-staff': UserCog,
  '/staaf/drivers': Car,
  '/staaf/conductors': Bus,
  '/staaf/security': Shield,
  '/staaf/recruitment': UserPlus,

  '/attnd/attndboard': Home,
  '/attnd/staff-attendance': UserCheck,
  '/attnd/student-attendance': CalendarCheck,

  '/acdmc/overview': Home,
  '/acdmc/lesson-plan': BookOpenText,
  '/acdmc/homework': ClipboardList,
  '/acdmc/assignment': FileText,
  '/acdmc/quiz': ListChecks,
  '/acdmc/curriculum': BookMarked,

  '/actvt/board': Home,
  '/actvt/houses': Flag,
  '/actvt/student-council': Users,
  '/actvt/clubs': Sparkles,
  '/actvt/tours': Plane,
  '/actvt/sports': Trophy,
  '/actvt/functions': PartyPopper,
  '/actvt/ranking': BarChart3,
  '/actvt/certificates': Award,

  '/mdcl/cases': Stethoscope,
  '/mdcl/supplies': Pill,

  '/asets/dashboard': Home,
  '/asets/assets': Boxes,
  '/asets/categories': Tags,
  '/asets/locations': MapPin,
  '/asets/allocations': UserCheck,
  '/asets/transfers': ArrowLeftRight,
  '/asets/maintenance': Wrench,
  '/asets/stock': Warehouse,
  '/asets/audits': ClipboardCheck,
  '/asets/vendors': Package,
  '/asets/procurement': ShoppingCart,
  '/asets/disposals': Trash2,
  '/asets/reports': FileBarChart,
  '/asets/settings': Settings,

  '/appnt/today': Clock,
  '/appnt/appointments': CalendarDays,
  '/appnt/availability': CalendarClock,
  '/appnt/hosts': UserCheck,
  '/appnt/reports': FileBarChart,
  '/appnt/settings': Settings,

  '/cpitl/dashboard': Home,
  '/cpitl/collection': Banknote,
  '/cpitl/fee-structures': Layers,
  '/cpitl/payments': Receipt,
  '/cpitl/fee-slips': FileSpreadsheet,
  '/cpitl/settings': SlidersHorizontal,
  '/cpitl/expenses': PieChart,
  '/cpitl/operating': Building2,
  '/cpitl/fuel': Fuel,
  '/cpitl/electricity': Zap,
  '/cpitl/infra': Construction,
  '/cpitl/budgets': PiggyBank,
  '/cpitl/salary': Wallet,
  '/cpitl/payroll': Coins,

  '/trnst': Home,
  '/trnst/vehicles': Bus,
  '/trnst/self-students': Users,
  '/trnst/routes': Route,

  '/dashboard': LayoutDashboard,
  '/centre-details': Info,
  '/exam-functionaries': UserCog,
  '/centre-guidelines': Megaphone,
  '/cbse-circulars': Megaphone,
  '/cbse-portals': Globe,
  '/subjects': BookOpen,
  '/undertaking': FileSignature,
  '/datesheets': CalendarDays,
  '/form66': FileCheck,
  '/examrooms': DoorOpen,
  '/answersheets': FileText,
  '/seatingplan': Armchair,
  '/duties': ClipboardCheck,
  '/attendance': CalendarCheck,
  '/pwd-info': Accessibility,
  '/stickers': Sticker,
  '/candidate-details': Contact,
  '/dispatch-slip': Send,
  '/remuneration': Wallet,

  '/exmcl/exam-functionaries': UserCog,
  '/exmcl/centre-guidelines': Megaphone,
  '/exmcl/admit-cards': Contact,
  '/exmcl/exams': ClipboardList,
  '/exmcl/result': BarChart3,
  '/exmcl/report-card': FileBarChart,
  '/exmcl/award-list': ListOrdered,
  '/exmcl/question-papers': FileQuestion,
  '/exmcl/syllabus': BookMarked,
  '/exmcl/marks-distribution': Scale,
  '/exmcl/subjects': BookOpen,
  '/exmcl/datesheets': CalendarDays,
  '/exmcl/examrooms': DoorOpen,
  '/exmcl/answersheets': FileText,
  '/exmcl/seatingplan': Armchair,
  '/exmcl/duties': ClipboardCheck,
  '/exmcl/attendance': CalendarCheck,
  '/exmcl/performas': FileDown,
  '/exmcl/cbse-registration': FileSignature,
}

/** Group headings (accordions without a route of their own). */
const BY_GROUP: Record<string, LucideIcon> = {
  'Time Table': CalendarDays,
  Income: Banknote,
  Expenses: Receipt,
  Payroll: Wallet,
  'Centre Details': Info,
  'Centre Records': Landmark,
}

export const navIconFor = (name: string, href?: string): LucideIcon | null =>
  (href ? BY_HREF[href] : undefined) || BY_GROUP[name] || null
